<div class="w-100 mt-0 tool-container">
  <h4>Download Mapping Solution Files</h4>
  <mat-form-field class="me-3 w-50">
    <mat-label>Solution and App</mat-label>
    <mat-select [(ngModel)]="solutionName">
      @for (solution of availableSolutions; track solution.value) {
        <mat-option [value]="solution.value">
          {{ solution.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="getMappingFile()"
    [disabled]="!solutionName"
  >
    Download
  </button>
  @if (downloadRecentSLF.status) {
    <h4 class="col-12 {{ downloadRecentSLF.statusClass }}">
      {{ downloadRecentSLF.status }}
    </h4>
  }
</div>
